<template>
  <a-select
          show-search
          :value="localValue"
          placeholder="input search text"
          style="width: 200px"
          :default-active-first-option="false"
          :show-arrow="true"
          :filter-option="false"
          :not-found-content="null"
          @search="handleSearch"
          @change="handleChange"
  >
    <a-select-option v-for="d in options" :key="d.value">
      {{ d.text }}
    </a-select-option>
  </a-select>
</template>
<script>
import {searchBadDic as getDic} from '../../../api/api';
import {getValByKey as getName} from '../../../api/api'
import mixin from '../mixin/AExtStringMixin'


export default {
    mixins:[mixin],
    data() {
        return {
            options: [],
            localValue: undefined,
        };
    },
    created(){
        this.init();
    },
    methods: {
        init(){
            if(this.localValue)
            {
                this.options=[];
                this.options.push({text:'加载中……',value:this.localValue});
                getName(this.localValue).then(result => {
                    if (result.data && result.data.succ) {
                        this.options=[];
                        this.options.push({text:result.data.data.name,value:this.localValue});
                    }
                }).catch(() => {
                    this.options=[];
                    this.options.push({text:'加载失败',value:this.localValue});
                })
            }
        },
        handleSearch(value) {
            getDic(value).then(result => {

                if (result.data && result.data.succ) {
                    const data = [];
                    result.data.data.forEach(r => {
                        data.push({
                            value: r.id,
                            text: r.name,
                        });
                    });
                    this.options = data
                }
            }).catch(() => {
                this.options = []
            })
        },
        handleChange(value,option) {
            this.localValue = value;
            getDic(option.text).then(result => {

                if (result.data && result.data.succ) {
                    const data = [];
                    result.data.data.forEach(r => {
                        data.push({
                            value: r.id,
                            text: r.name,
                        });
                    });
                    this.options = data
                }
            }).catch(() => {
                this.options = []
            })

        },
    },
};
</script>
